<!-- STANDARD Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa"  
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"  
       style="margin-right: 10px; cursor: pointer;"  
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- STANDARD Modal Body -->
<div class="modal-body" [hidden]="minimise">
  <!-- SMALL loader for form content only -->
  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}
  
  @if (!showFormLoader) {
<div>
    <form name="dataServiceForm" id="dataServiceForm" novalidate>
      <div class="fluid-container">
        
        <!-- Service Name -->
        <div class="form-group">
          <label class="async-loader-container">Service Name*</label>
          <input class="form-control" 
                 type="text" 
                 name="serviceName" 
                 [(ngModel)]="serviceData.serviceName"
                 (ngModelChange)="validateForm()"
                 required>
          @if (formErrors.serviceName) {
<span class="form-error-container">
            Service name is required.
          </span>
}
        </div>

        <!-- Records Limit -->
        <div class="form-group">
          <label class="async-loader-container">Records Limit</label>
          <input class="form-control" 
                 type="text" 
                 name="recordLimit" 
                 [(ngModel)]="serviceData.recordLimit">
        </div>

        <!-- Clients Selection -->
        <div class="form-group">
          <label class="async-loader-container">Clients</label>
          <div class="custom-multiselect" 
               [class.open]="clientDropdownOpen">
            <button type="button" 
                    class="mul-select-btn"
                    (click)="toggleClientDropdown($event)">
              <span class="selected-text">{{ getSelectedClientsText() }}</span>
              <span class="caret"></span>
            </button>
            @if (clientDropdownOpen) {
<div class="dropdown-menu" 
                
                 (click)="$event.stopPropagation()">
              <div class="dropdown-header">
                <button type="button" 
                        class="dropdown-action-btn"
                        (click)="selectAllClients(); $event.stopPropagation()">
                  Select all
                </button>
                <button type="button" 
                        class="dropdown-action-btn"
                        (click)="unselectAllClients(); $event.stopPropagation()">
                  Unselect all
                </button>
              </div>
              <div class="dropdown-items">
                @for (client of clients; track $index) {
<label 
                       class="dropdown-item"
                       (click)="$event.stopPropagation()">
                  <input type="checkbox"
                         [checked]="isClientSelected(client)"
                         (change)="toggleClientSelection(client)">
                  <span>{{ client.name }}</span>
                </label>
}
              </div>
            </div>
}
          </div>
        </div>

        <!-- Service Output Definition -->
        <div class="form-group">
          <label class="async-loader-container">Service Output Definition*</label>
          <select class="form-control" 
                  [(ngModel)]="serviceData.serviceOutputDef"
                  (ngModelChange)="validateForm()"
                  name="serviceOutputDef"
                  required>
            @for (option of options; track $index) {
<option 
                    [value]="option.value">
              {{option.name}}
            </option>
}
          </select>
          @if (formErrors.serviceOutputDef) {
<span class="form-error-container">
            Service output definition is required to get the data service results.
          </span>
}
        </div>

        <!-- Procedure Call -->
        @if (isProcCall()) {
<div class="form-group">
          <label class="async-loader-container">Procedure Call*</label>
          <input class="form-control" 
                 type="text" 
                 name="proc_call" 
                 [(ngModel)]="serviceData.proc_call"
                 (ngModelChange)="validateForm()"
                 [required]="isProcCall()">
          @if (isProcCall() && formErrors.proc_call) {
<span class="form-error-container">
            Procedure call is required.
          </span>
}
        </div>
}

        <!-- Procedure Input Params -->
        @if (isProcCall()) {
<div class="form-group">
          <label class="async-loader-container">Procedure Input Params*</label>
          <input class="form-control" 
                 type="text" 
                 name="proc_input" 
                 [(ngModel)]="serviceData.proc_input"
                 (ngModelChange)="validateForm()"
                 placeholder="sso_id:String:null,tax_year:String:2021" 
                 [required]="isProcCall()">
          @if (isProcCall() && formErrors.proc_input) {
<span class="form-error-container">
            Procedure input params are required.
          </span>
}
        </div>
}

        <!-- Procedure Output Params -->
        @if (isProcCall()) {
<div class="form-group">
          <label class="async-loader-container">Procedure Output Params*</label>
          <input class="form-control" 
                 type="text" 
                 name="proc_output" 
                 [(ngModel)]="serviceData.proc_output"
                 (ngModelChange)="validateForm()"
                 placeholder="resultset:OracleTypes.CURSOR,retval:OracleTypes.VARCHAR,error_out:OracleTypes.VARCHAR" 
                 [required]="isProcCall()">
          @if (isProcCall() && formErrors.proc_output) {
<span class="form-error-container">
            Procedure output params are required.
          </span>
}
        </div>
}

        <!-- Service Output -->
        @if (isStoredOutput()) {
<div class="form-group">
          <label class="async-loader-container">Service Output*</label>
          <input class="form-control" 
                 type="text" 
                 name="service_output" 
                 [(ngModel)]="serviceData.service_output"
                 (ngModelChange)="validateForm()"
                 [required]="isStoredOutput()">
          @if (isStoredOutput() && formErrors.service_output) {
<span class="form-error-container">
            Service output is required.
          </span>
}
        </div>
}

        <!-- Service Access SSO -->
        <div class="form-group">
          <label class="async-loader-container">SSO's to access service</label>
          <input class="form-control" 
                 type="text" 
                 name="service_access_sso" 
                 [(ngModel)]="serviceData.service_access_sso"
                 placeholder="Give list of sso (other than system defaults) comma separated just to give access to the current data service">
        </div>
        
      </div>
    </form>
  </div>
}
</div>

<!-- STANDARD Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button class="save-button"  
          type="button"  
          [disabled]="isSaveClicked || !isFormValid"  
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
  </button>
  <button class="reset-button"  
          type="button"  
          (click)="reset()">Reset Form</button>
  <button class="cancel-button"  
          type="button"  
          (click)="cancel()">Cancel</button>
</div>
